import { render, staticRenderFns } from "./RadioPrimaryButton.vue?vue&type=template&id=d4e67d6c&scoped=true"
import script from "./RadioPrimaryButton.vue?vue&type=script&lang=ts"
export * from "./RadioPrimaryButton.vue?vue&type=script&lang=ts"
import style0 from "./RadioPrimaryButton.vue?vue&type=style&index=0&id=d4e67d6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e67d6c",
  null
  
)

export default component.exports